import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  contentChildren,
  input,
  output,
  ViewEncapsulation,
} from '@angular/core';
import { Swiper, SwiperOptions } from 'swiper';
import { SwiperModule } from 'swiper/angular';
import { AccredibleCarouselItemComponent } from '../carousel-item/carousel-item.component';

@Component({
  standalone: true,
  selector: 'accredible-base-carousel',
  imports: [CommonModule, SwiperModule],
  templateUrl: './base-carousel.component.html',
  styleUrls: ['./base-carousel.component.scss'],
  // ViewEncapsulation.None is needed in order for the swiper.min.css to be applied
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccredibleBaseCarouselComponent {
  options = input<SwiperOptions>();

  swiperRef = output<Swiper>();

  carouselItems = contentChildren(AccredibleCarouselItemComponent, { descendants: true });

  onSwiper(swiper: Swiper): void {
    this.swiperRef.emit(swiper);
  }
}
